"use strict";

exports.__esModule = true;
exports.cancellationPolicyFactory = void 0;

const cancellationPolicyFactory = ({
  currentUnitPolicy,
  formatPrice,
  displayCurrency
}) => {
  var _currentUnitPolicy$po, _currentUnitPolicy$po2;

  const sellingPrice = currentUnitPolicy == null ? void 0 : (_currentUnitPolicy$po = currentUnitPolicy.policy) == null ? void 0 : _currentUnitPolicy$po.sellingAmount;
  const chargedAmount = currentUnitPolicy == null ? void 0 : (_currentUnitPolicy$po2 = currentUnitPolicy.policy) == null ? void 0 : _currentUnitPolicy$po2.chargedAmount;
  return { ...currentUnitPolicy,
    policy: { ...currentUnitPolicy.policy,
      displayChargedAmount: chargedAmount ? formatPrice(chargedAmount) : '0',
      displaySellingAmount: sellingPrice ? formatPrice(sellingPrice) : '0',
      displayCurrency
    }
  };
};

exports.cancellationPolicyFactory = cancellationPolicyFactory;